// Core
import React, { useState } from "react";
import { MdDeleteOutline } from "react-icons/md";

// Styles
import "./styles.scss";

// Assets
import searchIcon from "../../Assets/Images/search.svg";

const InputBox = React.forwardRef(({
  label,
  type = "text",
  placeholder = "Enter here",
  value,
  onChange,
  name,
  required = false,
  inputStyle = {},
  eyeIconStyle = {},
  labelStyle = {},
  isSearch = false,
  isRecommendation = false,
  isAdd,
  isDelete,
  handleDelete,
  handleAdd,
  disabled = false,
  maxLength,
  ...rest
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const isTextarea = type === "textarea";
  const isPassword = type === "password";

  return (
    <div className="input-container">
      {label && (
        <label style={labelStyle} htmlFor={name}>
          {label}
          {required && " *"}
        </label>
      )}
      {isTextarea ? (
        <div className="input-wrapper">
          <textarea
            ref={ref}
            id={name}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            // maxLength={maxLength} 
            style={inputStyle}
            disabled={disabled}
            className={rest.className}
          />
          {isAdd && disabled === false && (
            <span className="addLabel" onClick={handleAdd}>
              Add New
            </span>
          )}
          {isDelete && (
            <MdDeleteOutline
              onClick={handleDelete}
              size={25}
              className="removeIcon"
            />
          )}
        </div>
      ) : (
        <div className="input-wrapper">
          {isSearch ? (
            <img src={searchIcon} alt="search" className="searchIcon" />
          ) : (
            ""
          )}
          <input
            type={isPassword && showPassword ? "text" : type} // Show/hide password
            id={name}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            style={inputStyle}
            disabled={disabled}
            className={
              isSearch
                ? "searchInputBox"
                : isRecommendation
                  ? "recommend-input"
                  : ""
            }
            {...rest}
          />
          {isPassword && (
            <span
              className="toggle-password-icon"
              style={{
                ...eyeIconStyle,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.5 : 1,
              }}
              onClick={togglePasswordVisibility}
            >
              {showPassword ? "👁️" : "👁️‍🗨️"}
            </span>
          )}

          {isAdd && (
            <span className="addLabel" onClick={handleAdd}>
              Add New
            </span>
          )}
          {isDelete && (
            <MdDeleteOutline
              onClick={handleDelete}
              size={25}
              className="removeIcon"
            />
          )}
        </div>
      )}
    </div>
  );
});

export default InputBox;
